module.exports = __webpack_public_path__ + "media/images/w_3-c5ec5c378908408089d7a872a8079f93.png";